export const DINE_IN = 'Dine-in';
export const TO_GO = 'To-go';
export const DELIVERY = 'Delivery';
